module.exports = __webpack_public_path__ + "static/media/Folder.9bd2dd47.svg";